const layout = () => import("../../gerente/layout.vue");
const gerente = () => import("./gerente.vue");

const gerenteRoutes = {
  component: layout,
  children: [
    {
      path: "",
      name: "gerente",
      component: gerente,
    },
  ],
};

export default gerenteRoutes;